import { render, staticRenderFns } from "./MainPageLoader.vue?vue&type=template&id=591b2f2d&scoped=true&"
import script from "./MainPageLoader.vue?vue&type=script&lang=js&"
export * from "./MainPageLoader.vue?vue&type=script&lang=js&"
import style0 from "./MainPageLoader.vue?vue&type=style&index=0&id=591b2f2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591b2f2d",
  null
  
)

export default component.exports